import { Cart } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from './Icon.types';

const OrderIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <Cart width={size} height={size} color={color} {...rest} />;

OrderIcon.displayName = 'OrderIcon';

export default OrderIcon;
